import { UseQueryResult } from '@tanstack/react-query';
import { useTrackedQuery as useQuery } from '@ais-ui/performance-tracking';
import { useSession } from '../SessionProvider';
import {
  getCountries,
  getFilterList,
  getGeoshapeslist,
  getNavigationalStatuses,
  getRegions,
  getShipTypes,
} from './getFilterValues';
import { Filter } from './filterEndpoints';

export const useGetCountries = (): UseQueryResult<string[] | null> => {
  const { olSession, sessionId } = useSession();

  return useQuery(
    {
      queryKey: ['getCountries'],
      queryFn: () => {
        return getCountries(olSession);
      },
      enabled: !!sessionId && !!olSession.sessionId,
    },
    'filterValues:countries',
  );
};

export const useGetShipTypes = (): UseQueryResult<string[] | null> => {
  const { olSession, sessionId } = useSession();

  return useQuery(
    {
      queryKey: ['getShipTypes'],
      queryFn: () => {
        return getShipTypes(olSession);
      },
      enabled: !!sessionId && !!olSession.sessionId,
    },
    'filterValues:shipTypes',
  );
};

export const useGetNavigationalStatuses = (): UseQueryResult<
  string[] | null
> => {
  const { olSession, sessionId } = useSession();

  return useQuery(
    {
      queryKey: ['getNavigationalStatuses'],
      queryFn: () => {
        return getNavigationalStatuses(olSession);
      },
      enabled: !!sessionId && !!olSession.sessionId,
    },
    'filterValues:navigationalStatuses',
  );
};

export const useGetRegions = (): UseQueryResult<string[] | null> => {
  const { olSession, sessionId } = useSession();

  return useQuery(
    {
      queryKey: ['getRegions'],
      queryFn: () => {
        return getRegions(olSession);
      },
      enabled: !!sessionId && !!olSession.sessionId,
    },
    'filterValues:regions',
  );
};

export const useGetFilterList = (): UseQueryResult<Filter[] | null> => {
  const { olSession, sessionId } = useSession();

  return useQuery(
    {
      queryKey: ['getFilterList'],
      queryFn: () => {
        return getFilterList(olSession);
      },
      enabled: !!sessionId && !!olSession.sessionId,
    },
    'filterValues:filterList',
  );
};

export const useGetGeoshapeslist = (): UseQueryResult<string[] | null> => {
  const { olSession, sessionId } = useSession();

  return useQuery(
    {
      queryKey: ['getGeoshapeslist'],
      queryFn: () => {
        return getGeoshapeslist(olSession);
      },
      enabled: !!sessionId && !!olSession.sessionId,
    },
    'filterValues:geoshapes',
  );
};
